import Vue from "vue";
import Router from "vue-router";

// import pageHome from './views/page-home.vue' // 首页
// import pageMemberManage from './views/page-member-manage' //会员管理页
// import pageOrderCare from './views/page-order-care' //订单关怀

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/redirection",
      name: "redirection",
      component: (resolve) => {
        require(["./views/redirection.vue"], resolve);
      },
    },
    {
      path: "/refresh",
      name: "refresh",
      component: (resolve) => {
        require(["./views/refresh.vue"], resolve);
      },
    },
    // {
    //   path: "*",
    //   redirect: '/integralCenter'
    // },
    {
      path: "/home",
      name: "home",
      component: (resolve) => {
        require(["./views/home/page_home.vue"], resolve);
      },
    },
    {
      path: "/prizeCenter", //积分授权页面
      name: "prizeCenter",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter.vue"], resolve);
      },
    },
    {
      path: "/prizeCenter2", //积分授权页面
      name: "prizeCenter2",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter2.vue"], resolve);
      },
    },
    {
      path: "/login",
      name: "home",
      component: (resolve) => {
        require(["./views/login/login.vue"], resolve);
      },
    },

    //积分中心
    {
      path: "/integralCenter",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "newhome" },
        },
        {
          path: "integralCenter",
          redirect: { name: "mutualMember" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "memberList" },
            },
            {
              path: "memberList",
              name: "memberList",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/mutualMember.vue",
                ], resolve);
              },
            },
            {
              path: "memberLevel",
              name: "memberLevel",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberLevel.vue",
                ], resolve);
              },
            },
            {
              path: "memberPower",
              name: "memberPower",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberPower.vue",
                ], resolve);
              },
            },
          ],
        },
        {
          path: "home",
          name: "newhome",
          component: (resolve) => {
            require(["./views/integralCenter/NewHome/page_home.vue"], resolve);
          },
        },

        // 小部件 0元试用
        {
          path: "cardManagement/freeTrial",
          name: "freeTrial?activityType=30",
          component: (resolve) => {
            require([
              "./views/integralCenter/cardManage/scratchers.vue",
            ], resolve);
          },
        },
        {
          path: "cardManagement/freeTrialEdit",
          name: "freeTrialEdit",
          meta: {
            activeMange: "freeTrial?activityType=30",
          },
          component: (resolve) => {
            require([
              "./views/integralCenter/cardManage/points_task_freeTrial.vue",
            ], resolve);
          },
        },
        // 小部件 刮刮乐
        {
          path: "cardManagement/scratch",
          name: "scratchers?activityType=29",
          component: (resolve) => {
            require([
              "./views/integralCenter/cardManage/scratchers.vue",
            ], resolve);
          },
        },
        {
          path: "cardManagement/scratchersEdit",
          name: "scratchersEdit",
          meta: {
            activeMange: "scratchers?activityType=29",
          },
          component: (resolve) => {
            require([
              "./views/integralCenter/cardManage/points_task_scratchers.vue",
            ], resolve);
          },
        },
        // 海报
        {
          path: "cardManagement/smartPost",
          name: "smartPoster?activityType=28",
          component: (resolve) => {
            require([
              "./views/integralCenter/cardManage/scratchers.vue",
            ], resolve);
          },
        },
        {
          path: "cardManagement/smartPosterEdit",
          name: "smartPosterEdit",
          meta: {
            activeMange: "smartPoster?activityType=28",
          },
          component: (resolve) => {
            require([
              "./views/integralCenter/cardManage/points_task_smartPoster.vue",
            ], resolve);
          },
        },
        {
          path: "cardManagement/liveCard",
          name: "liveCard",
          component: (resolve) => {
            require(["./views/liveCard/liveCard.vue"], resolve);
            // require(["./views/liveCard/activeCard.vue"], resolve);
          },
          // children: [
          //   {
          //     path: '',
          //     redirect: { name: 'liveCard' }
          //   },
          //   {
          //     path: 'activeCard',
          //     name: 'activeCard',
          //     component: (resolve) => {
          //       require(['./views/liveCard/activeCard.vue'], resolve)
          //     }
          //   }]
        },
        {
          path: "activeCard",
          name: "activeCard",
          component: (resolve) => {
            require(["./views/liveCard/activeCard.vue"], resolve);
          },
        },
        // {
        //   path: "liveCard1",
        //   name: "liveCard1",
        //   component: (resolve) => {
        //     require(["./views/liveCard/liveCard1.vue"], resolve);
        //   },
        // },
        {
          path: "integralTask",
          name: "integralTask",
          component: (resolve) => {
            require(["./views/integralCenter/integralTask.vue"], resolve);
          },
        },
        {
          path: "integralEden",
          name: "integralEden",
          component: (resolve) => {
            require(["./views/integralCenter/integralEden.vue"], resolve);
          },
        },
        {
          path: "shopDecoration",
          name: "shopDecoration",
          component: (resolve) => {
            require(["./views/integralCenter/shopDecoration.vue"], resolve);
          },
        },
        {
          path: "integralMall",
          name: "integralMall",
          component: (resolve) => {
            require(["./views/integralCenter/integralMall.vue"], resolve);
          },
        },
        {
          path: "gameHub",
          name: "gameHub",
          component: (resolve) => {
            require(["./views/integralCenter/gameHub.vue"], resolve);
          },
        },
        {
          path: "interesting",
          name: "interesting",
          component: (resolve) => {
            require(["./views/integralCenter/gameHub.vue"], resolve);
          },
        },
        {
          path: "mutualMember",
          name: "mutualMember",
          component: (resolve) => {
            require([
              "./views/integralCenter/memberCenter/mutualMember.vue",
            ], resolve);
          },
        },
        {
          path: "memberLevel",
          name: "memberLevel",
          component: (resolve) => {
            require([
              "./views/integralCenter/memberCenter/memberLevel.vue",
            ], resolve);
          },
        },
        //奖品中心
        {
          path: 'prizeCenter',
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'prizeCenter' }
            },
            {
              path: 'coupon_management',
              name: 'coupon_management',
              component: (resolve) => {
                require(['./views/integralCenter/coupon_management.vue'], resolve)
              }
            }, {
              path: 'asset_management',
              name: 'asset_management',
              component: (resolve) => {
                require(['./views/integralCenter/asset_management.vue'], resolve)
              }
            }
          ]
        },
        //推广方式
        {
          path: 'promotionMode',
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'promotionMode' }
            },
            {
              path: 'suspension_diagram',
              name: 'suspension_diagram',
              component: (resolve) => {
                require(['./views/integralCenter/suspension_diagram.vue'], resolve)
              }
            },
          ]
        },
        {
          path: "dataAnalysis",
          // redirect:{ name:'dataAnalysis' },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "dataAnalysis" },
            },
            {
              path: "flow_analysis",
              name: "flow_analysis",
              component: (resolve) => {
                require(["./views/integral/flow_analysis.vue"], resolve);
              },
            },
            {
              path: "prize_statistics",
              name: "prize_statistics",
              component: (resolve) => {
                require(["./views/integral/prize_statistics.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "mutualMember",
          // redirect:{ name:'dataAnalysis' },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "mutualMember" },
            },
            {
              path: "memberList",
              name: "memberList",
              component: (resolve) => {
                require(["./views/integralCenter/memberCenter/mutualMember.vue"], resolve);
              },
            },
            {
              path: "levelPrivilege",
              name: "levelPrivilege",
              component: (resolve) => {
                require(["./views/integralCenter/memberCenter/levelPrivilege.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "brandCustom", // 品牌定制
          name: "brandCustom",
          component: (resolve) => {
            require(["./views/brandCustom/index.vue"], resolve);
          },
        },
        {
          path: "riskManagement", // 风控管理
          name: "riskManagement",
          component: (resolve) => {
            require(["./views/riskManagement/riskManagement.vue"], resolve);
          },
        },



        {
          path: "integralTask/signIn", // 活动
          name: "signIn",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/Grabgifts", // 活动
          name: "Grabgifts",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/followShop", // 活动
          name: "followShop",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/inviteShop", // 活动
          name: "inviteShop",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/inviteCard", // 活动
          name: "inviteCard",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/perfectNews", // 活动
          name: "perfectNews",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/redPacket", // 活动
          name: "redPacket",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/fission", // 活动
          name: "fission",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/bankCard", // 活动
          name: "bankCard",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/giftShop", // 活动
          name: "giftShop",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/giftQr", // 活动
          name: "giftQr",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/firstPurchase", // 活动
          name: "firstPurchase",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        //Note----入会打榜，幸运抽签，0元试用
        {
          path: "integralTask/joinAndRank", // 活动
          name: "joinAndRank",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/luckyLottery", // 活动
          name: "luckyLottery",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralTask/freeTryOut", // 活动
          name: "freeTryOut",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        //Note-----结束 
        {
          path: "integralEden/fgPurchase", // 活动
          name: "fgPurchase",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/overbooking", // 活动
          name: "overbooking",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/orderRank", // 下单冲榜
          name: "orderRank",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/orderRankPage", // 创建下单冲榜活动
          name: "orderRankPage",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_order.vue"], resolve);
          },
        },
        {
          path: "integralEden/fulfilQuota", // 活动
          name: "fulfilQuota",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/fulfilQuotaPage", //满额有礼
          name: "fulfilQuotaPage",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_fulfilQuota.vue"], resolve);
          },
        },
        {
          path: "integralEden/lottergdraw", // 活动
          name: "lottergdraw",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        }, 
        {
          path: "integralEden/questionnaire", // 调查问卷
          name: "questionnaire",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/birthdayGift", // 生日有礼
          name: "birthdayGift",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/memberUpgradeGift", // 生日有礼
          name: "memberUpgradeGift",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/pointExchange", // 积分兑换
          name: "pointExchange",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "integralEden/estimate", // 活动
          name: "estimate",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },

        {
          path: "interesting/turntable", // 活动
          name: "turntable",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "gameHub/prizeClaw", // 活动
          name: "prizeClaw",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },
        {
          path: "gameHub/differences", // 活动
          name: "differences",
          component: (resolve) => {
            require(["./views/huodong/index.vue"], resolve);
          },
        },


        {
          path: "integralTask/activity", // 活动
          name: "activity",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_activity.vue"], resolve);
          },
        },
        {
          path: "integralTask/Invites", // 活动
          name: "Invites",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_Invite.vue"], resolve);
          },
        },
        //Note--------使用此模板入会打榜
        {
          path: "integralTask/games", // 活动
          name: "games",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_join.vue"], resolve);
          },
        },
        //Note--------使用此模板0元试用
        {
          path: "integralTask/trial", // 活动
          name: "trial",
          component: (resolve) => {
              require(["./views/integralCenter/points_task_trial.vue"], resolve);
          },
        },
        //Note--------使用此模板幸运抽奖
        {
          path: "integralTask/luckyDraw", // 活动
          name: "luckyDraw",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_luckyDraw.vue"], resolve);
          },
        },
        {
          path: "integralTask/luckyLottery", // 活动
          name: "luckyLottery",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_join.vue"], resolve);
          },
        },
      
        {
          path: "integralEden/electric", // 活动
          name: "electric",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_electric.vue"], resolve);
          },
        },
        // <!-- 红包雨 --><!-- 裂变神券 -->
        {
          path: "integralTask/evaluation", // 活动
          name: "evaluation",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_evaluation.vue"], resolve);
          },
        },
        // <!-- 评价有礼 -->
        {
          path: "integralEden/evaluation", // 活动
          name: "evaluation",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_evaluation.vue"], resolve);
          },
        },

        // 活动列表
        {
          path: "integralTask/activeList", // 活动
          name: "activeList",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
        },
        {
          path: "integralEden/activeList1", // 活动
          name: "activeList1",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
        },
        {
          path: "interesting/activeList2", // 活动
          name: "activeList2",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
        },
        {
          path: "gameHub/activeList3", // 活动
          name: "activeList3",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
        },
        // <!-- 下单有礼 复购 shougou -->
        {
          path: "integralEden/polite", // 活动
          name: "polite",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_polite.vue"], resolve);
          },
        },
        // <!-- 大转盘 -->
        {
          path: "interesting/step", // 活动
          name: "step",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_step.vue"], resolve);
          },
        },
        // <!-- 下单抽奖 -->
        {
          path: "interesting/step", // 活动
          name: "step",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_step.vue"], resolve);
          },
        },

        {
          path: "integralEden/step2",
          name: "step2",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_step2.vue"], resolve);
          },
        },

        {
          path: "gameHub/games", // 活动
          name: "games",
          component: (resolve) => {
            require(["./views/integralCenter/points_task_games.vue"], resolve);
          },
        },

        //调查问卷
        {
          path: "integralEden/question",
          name: "question",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_question.vue"], resolve);
          },
        },
        //生日有礼
        {
          path: "integralEden/birthday",
          name: "birthday",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_birthdayGift.vue"], resolve);
          },
        },

        //积分兑换
        {
          path: "integralEden/exchange",
          name: "exchange",
          component: (resolve) => {
            require(["./views/integralCenter/create_activity_pointExchange.vue"], resolve);
          },
        },

        //会员升级礼
        {
            path: "integralEden/memberUpgrade",
              name: "memberUpgrade",
              component: (resolve) => {
                require(["./views/integralCenter/created_activity_memberUpgrade.vue"], resolve);
              },
        },

        // {
        //   path: "integralTask/activeEdit", // 活动
        //   name: "activeEdit",
        //   component: (resolve) => {
        //     require(["./views/huodongedit/index.vue"], resolve);
        //   },
        // },
        // {
        //   path: "integralEden/activeEdit", // 活动
        //   name: "activeEdit1",
        //   component: (resolve) => {
        //     require(["./views/huodongedit/index.vue"], resolve);
        //   },
        // },
        // {
        //   path: "interesting/activeEdit", // 活动
        //   name: "activeEdit2",
        //   component: (resolve) => {
        //     require(["./views/huodongedit/index.vue"], resolve);
        //   },
        // },
        // {
        //   path: "gameHub/activeEdit", // 活动
        //   name: "activeEdit3",
        //   component: (resolve) => {
        //     require(["./views/huodongedit/index.vue"], resolve);
        //   },
        // },
        // {
        //   path: "huodongfrom", // 活动
        //   name: "huodongfrom",
        //   component: (resolve) => {
        //     require(["./views/huodongfrom/index.vue"], resolve);
        //   },
        // },
        // {
        //     path: 'promotionMode/suspension_diagram',
        //     name: 'suspension_diagram',
        //     component: (resolve) => {
        //       require(['./views/promotionMode/index.vue'], resolve)
        //     }
        // },

      ],
    },
    //店铺装修
    {
      path: "/draw",
      component: (resolve) => {
        require(["./views/integralCenter/draw/draw.vue"], resolve)
      },
    },
    // 高级功能列表开发
    // {
    //   path: 'show_advanced_version',
    //   name: 'show_advanced_version',
    //   component: (resolve) => {
    //     require(["./views/advancedVersion.vue"], resolve);
    //   },
    //   meta: {
    //     typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
    //   }
    // },
    {
      path: '/*/*/*_version1',
      name: 'commodity_analysis_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version1',
      name: 'commodity_analysis_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version2',
      name: 'auto_market_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 1, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version2',
      name: 'auto_market_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 1, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version3',
      name: 'loyalty_selft_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 2, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version3',
      name: 'loyalty_selft_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 2, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version4',
      name: 'loyalty_pop_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 3, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version4',
      name: 'loyalty_pop_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 3, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },

  ],
});
